import React, { memo, useCallback, useState, useMemo } from 'react';
import { createUseStyles, Password, Button, Advice } from 'hoi-poi-ui';
import useLoginLiterals from "../../../lib/useLoginLiterals";
import { FadeTransition } from "../../../components/Transitions";
import AuthBox from "../components/AuthBox";
import styles from "./styles.js";
import PasswordPolicies from "../components/PasswordPolicies";
const useStyles = createUseStyles(styles, 'ExpiredPassword');
const ExpiredPassword = _ref => {
  let {
    logo,
    onSend,
    goLogin,
    iframeURL,
    policies
  } = _ref;
  const classes = useStyles();
  const [password, setPassword] = useState();
  const [password2, setPassword2] = useState();
  const [passwordError, setPasswordError] = useState();
  const [formState, setFormState] = useState({
    error: null,
    success: null,
    loading: false
  });
  const {
    loading,
    t
  } = useLoginLiterals();
  const send = useCallback(e => {
    var _e$preventDefault;
    e === null || e === void 0 ? void 0 : (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 ? void 0 : _e$preventDefault.call(e);
    if (!password || password !== password2) return;
    setFormState({
      error: null,
      success: null,
      loading: true
    });
    onSend(password).then(successLiteral => {
      setFormState({
        success: t(successLiteral),
        error: false,
        loading: false
      });
      setPassword('');
      setPassword2('');
    }).catch(e => {
      let error = t('error_generalerror');
      if (e !== null && e !== void 0 && e.message) error = t(e.message);
      setFormState({
        success: false,
        error: error,
        loading: false
      });
    });
  }, [onSend, password, password2, t]);
  const checkPasswords = useCallback(() => {
    setPasswordError(password && password2 && password !== password2 ? t('error_password_validation') : '');
  }, [password, password2, t]);
  const allValid = useMemo(() => {
    return policies.every(policy => policy.condition(password)) && password === password2;
  }, [password, password2, policies]);
  if (loading) return null;
  return /*#__PURE__*/React.createElement(AuthBox, {
    title: t('error_password_expired'),
    logo: logo,
    iframeURL: iframeURL ? t(iframeURL) : null
  }, !formState.success && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "error",
    show: formState.error
  }, /*#__PURE__*/React.createElement(Advice, {
    className: classes.advice,
    type: "error",
    showIcon: true,
    defaultCollapsed: false,
    showCollapse: false
  }, formState.error)), /*#__PURE__*/React.createElement("form", {
    autoComplete: "off",
    onSubmit: send
  }, /*#__PURE__*/React.createElement(Password, {
    label: t('label_new_password'),
    placeholder: t('label_password'),
    onChange: setPassword,
    onBlur: checkPasswords,
    value: password,
    isFullWidth: true,
    isDisabled: formState.loading,
    autoFocus: true
  }), /*#__PURE__*/React.createElement(PasswordPolicies, {
    password: password,
    policies: policies,
    t: t
  }), /*#__PURE__*/React.createElement(Password, {
    label: t('label_insert_repeat_new_password'),
    placeholder: t('label_password'),
    onChange: setPassword2,
    onBlur: checkPasswords,
    value: password2,
    isFullWidth: true,
    isDisabled: formState.loading,
    error: passwordError
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: send,
    isLoading: formState.loading,
    isDisabled: !allValid
  }, t('action_reset_password'))))), /*#__PURE__*/React.createElement(FadeTransition, {
    transitionKey: "sucess",
    show: formState.success
  }, /*#__PURE__*/React.createElement(Advice, {
    className: classes.advice,
    type: "success",
    showIcon: true,
    defaultCollapsed: false,
    showCollapse: false
  }, formState.success), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: goLogin
  }, t('action_go_to_forcemanager')))));
};
export default /*#__PURE__*/memo(ExpiredPassword);